var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 0.333332C5.83325 0.333332 2.27492 2.925 0.833252 6.58333C2.27492 10.2417 5.83325 12.8333 9.99992 12.8333C14.1666 12.8333 17.7249 10.2417 19.1666 6.58333C17.7249 2.925 14.1666 0.333332 9.99992 0.333332ZM9.99992 10.75C7.69992 10.75 5.83325 8.88333 5.83325 6.58333C5.83325 4.28333 7.69992 2.41667 9.99992 2.41667C12.2999 2.41667 14.1666 4.28333 14.1666 6.58333C14.1666 8.88333 12.2999 10.75 9.99992 10.75ZM9.99992 4.08333C8.61658 4.08333 7.49992 5.2 7.49992 6.58333C7.49992 7.96667 8.61658 9.08333 9.99992 9.08333C11.3833 9.08333 12.4999 7.96667 12.4999 6.58333C12.4999 5.2 11.3833 4.08333 9.99992 4.08333Z",
    fill: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.59913310af66876121df39f01f79fcdb.svg";
export { ForwardRef as ReactComponent };